export const version = 'HEAD';
export const buildDate = '2026-03-11T05:26:12.639Z';
export const commitHash = 'd2f9ad1';